import store from '@/store'
const globalTool = {
    isAdmin() {
        const name = (store && store.state && (store.state.name || (store.state.user && store.state.user.name))) || ''
        return name === 'admin' || name === 'oa_admin'
    },
    getOrgData() {
        return {
            // 需要判断为不完空，为空就返回””
            orgId: (store && store.state && (store.state.user && store.state.user.user && store.state.user.user.userOrgId)) || '',
            orgName: (store && store.state && (store.state.user && store.state.user.user && store.state.user.user.userOrgName)) || '',
            realName: (store && store.state && (store.state.user && store.state.user.user && store.state.user.user.realName)) || '',
            userId: (store && store.state && (store.state.user && store.state.user.user && store.state.user.user.userId)) || '',
        }
    },
}

export default globalTool
